import { MAIN_INCOME_SOURCE } from '@Types/consts.ts';

export const BUSINESS_MAIN_TYPES = {
  PARTNERSHIP: 'PARTNERSHIP',
  [MAIN_INCOME_SOURCE.LLC]: MAIN_INCOME_SOURCE.LLC,
  SOLE_PROPRIETORSHIP: 'SOLE_PROPRIETORSHIP',
  CORPORATION: 'CORPORATION',
  [MAIN_INCOME_SOURCE.NON_PROFIT]: MAIN_INCOME_SOURCE.NON_PROFIT,
} as const;
export type BusinessMainTypes = (typeof BUSINESS_MAIN_TYPES)[keyof typeof BUSINESS_MAIN_TYPES];

export const BUSINESS_SUB_TYPES = {
  [MAIN_INCOME_SOURCE.GENERAL_PARTNERSHIP]: MAIN_INCOME_SOURCE.GENERAL_PARTNERSHIP,
  [MAIN_INCOME_SOURCE.LIMITED_LIABILITY_PARTNERSHIP]:
    MAIN_INCOME_SOURCE.LIMITED_LIABILITY_PARTNERSHIP,
  [MAIN_INCOME_SOURCE.SOLE_PROP_DBA]: MAIN_INCOME_SOURCE.SOLE_PROP_DBA,
  [MAIN_INCOME_SOURCE.SOLE_PROP_NO_DBA]: MAIN_INCOME_SOURCE.SOLE_PROP_NO_DBA,
  [MAIN_INCOME_SOURCE.S_CORP]: MAIN_INCOME_SOURCE.S_CORP,
  [MAIN_INCOME_SOURCE.C_CORP]: MAIN_INCOME_SOURCE.C_CORP,
} as const;
export type BusinessSubTypes = (typeof BUSINESS_SUB_TYPES)[keyof typeof BUSINESS_SUB_TYPES];

export const BUSINESS_TYPES = {
  ...BUSINESS_MAIN_TYPES,
  ...BUSINESS_SUB_TYPES,
} as const;
export type BusinessTypes = (typeof BUSINESS_TYPES)[keyof typeof BUSINESS_TYPES];

export const BUSINESS_MAIN_TO_SUB_TYPE_MAP = {
  [BUSINESS_MAIN_TYPES.PARTNERSHIP]: [
    BUSINESS_SUB_TYPES.GENERAL_PARTNERSHIP,
    BUSINESS_SUB_TYPES.LLP,
  ],
  [BUSINESS_MAIN_TYPES.SOLE_PROPRIETORSHIP]: [BUSINESS_SUB_TYPES.DBA, BUSINESS_SUB_TYPES.SSN],
  [BUSINESS_MAIN_TYPES.CORPORATION]: [BUSINESS_SUB_TYPES.S_CORP, BUSINESS_SUB_TYPES.C_CORP],
} as const satisfies Partial<Record<BusinessMainTypes, BusinessSubTypes[]>>;

export type BusinessMainTypesWithSubTypes = keyof typeof BUSINESS_MAIN_TO_SUB_TYPE_MAP;

export enum BusinessTypeFlows {
  DEFAULT = 'DEFAULT',
  NONUS = 'NONUS',
}
export const MAIN_BUSINESS_TYPE_FLOW_MAP = {
  [BusinessTypeFlows.DEFAULT]: [
    BUSINESS_MAIN_TYPES.CORPORATION,
    BUSINESS_MAIN_TYPES.LLC,
    BUSINESS_MAIN_TYPES.PARTNERSHIP,
    BUSINESS_MAIN_TYPES.NON_PROFIT,
    BUSINESS_MAIN_TYPES.SOLE_PROPRIETORSHIP,
  ],
  [BusinessTypeFlows.NONUS]: [
    BUSINESS_MAIN_TYPES.CORPORATION,
    BUSINESS_MAIN_TYPES.LLC,
    BUSINESS_MAIN_TYPES.PARTNERSHIP,
  ],
} as const satisfies Record<BusinessTypeFlows, BusinessMainTypes[]>;
